import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { ApplicationSubmoduleSchema } from './application-current-submodule.types';

export const APPLICATION_SUBMODULE_API_URL = new InjectionToken<string>('Application submodule api url');

@Injectable()
export class ApplicationCurrentSubmoduleApiService {
  readonly #http = inject(HttpClient);
  readonly #url = inject(APPLICATION_SUBMODULE_API_URL);

  get(submodule: string, personId: string, optionalParams?: { device?: string | null }): Observable<ApplicationSubmoduleSchema> {
    let params = new HttpParams({ fromObject: { submodule, personId } });

    if (optionalParams) {
      if (optionalParams.device) {
        params = params.set('device', optionalParams.device);
      }
    }

    return this.#http.get<ApplicationSubmoduleSchema>(this.#url, { params });
  }
}
